import React, {
  useState,
  useEffect,
  useRef,
  forwardRef
} from "react";
import TextInputValidator from "../conventionFields/TextInputValidator";
import TextCounter from "../conventionFields/TextCounter";
import styled from 'styled-components';

import { multiLineTextToArray, longestString, arrayToText } from "../shared/StringUtilities";

const StyledTextarea = styled.textarea`
    min-width: 300px;
    min-height: 100px;
    padding-left: 4px;
    font-size: inherit;
    line-height: inherit;
    color: inherit;
    border: none;

    &:focus {
      outline: none;
    }
`;

const arrayOfValues = (valueObjects) => {
  if (!valueObjects || !Array.isArray(valueObjects)) return [];
  return valueObjects.map(item => item.value);
}

export default forwardRef((props, ref) => {
  const [valueObject, setValueObject] = useState(props.value || []);
  const textValues = arrayOfValues(props.value || []);
  const [rawText, setRawText] = useState(arrayToText(textValues));
  const [valid, setValid] = useState(true);
  const [editing, setEditing] = useState(true);
  const refInput = useRef(null);

  const textValidator = new TextInputValidator(props.textLimit, props.allowedCharacters, props.prohibitedCharacters);

  useEffect(() => {
    setTimeout(() => refInput.current.focus());
  }, []);

  useEffect(() => {
    if (!editing) {
      props.api.stopEditing();
    }
  }, [editing]);

  const onChangeHandler = (e) => {
    let text = e.target.value;
    let textValues = multiLineTextToArray(text);
    let arrayOfObjects = [];

    let tempValid = true;

    for (const item of textValues) {
      const newValue = textValidator.validate(item)
      const newValueObject = { value: newValue }
      tempValid = tempValid && (newValue === item);
      arrayOfObjects = arrayOfObjects.concat(newValueObject);
    }

    setValid(tempValid);
    setValueObject(arrayOfObjects);
    setRawText(text);

    // AG Grid v32: Call onValueChange to notify grid of value changes
    if (props.onValueChange) {
      props.onValueChange(arrayOfObjects);
    }
  }

  const handleOnBlur = () => {
    setEditing(false);
  }

  const longestValue = longestString(arrayOfValues(valueObject))

  return (
    <div className='multi-text-cell-container bg-white' style={{ minWidth: '300px' }} >
      <StyledTextarea
        rows={5}
        placeholder="Enter one value on each line"
        ref={refInput}
        value={rawText}
        onChange={onChangeHandler}
        onBlur={handleOnBlur}
      />
      <div className="text-size-small" style={{ marginTop: '2px', padding: '2px' }}>
        {props.textLimit > 0 &&
          <span>
            For longest value:&nbsp;
            <TextCounter maxCount={props.textLimit} currentValue={longestValue} counterClassNames="text-semibold" />
          </span>
        }
        {!valid && <span className='text-danger text-semibold pull-right'>Invalid</span>}
      </div>
    </div>
  );
});